import { inject } from '@angular/core';
import { CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { RouterLinkFactory } from '../router/router-link-factory';
import { LAUNDRY_DELIVERY, LAUNDRY_STAFF, USER_DATA } from '../utils/constant';

export const roleGuard: CanActivateFn = (route, state: RouterStateSnapshot) => {
  const links = inject(RouterLinkFactory);
  const router = inject(Router);
  const userData = JSON.parse(localStorage.getItem(USER_DATA) || '{}') ?? '';
  const requestedPath = state.url.split('?')[0];
  const isPrintRoute = requestedPath.startsWith('/print/');
  const isCollectionPointOnlyStaff =
    userData.role === LAUNDRY_STAFF &&
    userData.onlyCollectionPoint === true;
  const allowedRoles = route.data['allowedRoles'] as string[] | undefined;
  const excludeCollectionPointOnly =
    route.data['excludeCollectionPointOnly'] === true;
  const allowedLaundryStaffRoutes = [
    links.orders()[0],
    links.deliveryOrders()[0],
    links.reports()[0],
    links.cashierCollectionReport()[0],
    links.laundryDailyOrderStatusReport()[0],
    links.creditSalesReport()[0],
    links.messages()[0],
    links.bills()[0],
  ];
  const allowedCollectionPointOnlyRoutes = [
    links.orders()[0],
    links.bills()[0],
    links.messages()[0],
  ];
  const isAllowedRoute = (allowedRoutes: string[]) =>
    allowedRoutes.some(
      (allowedRoute) =>
        requestedPath === allowedRoute ||
        requestedPath.startsWith(`${allowedRoute}/`)
    );

  if (isPrintRoute) {
    return true;
  }

  if (
    (allowedRoles && !allowedRoles.includes(userData.role)) ||
    (excludeCollectionPointOnly && isCollectionPointOnlyStaff)
  ) {
    return router.createUrlTree(links.orders());
  }

  if (
    (isCollectionPointOnlyStaff &&
      !isAllowedRoute(allowedCollectionPointOnlyRoutes)) ||
    (userData.role === LAUNDRY_STAFF &&
      !isCollectionPointOnlyStaff &&
      !isAllowedRoute(allowedLaundryStaffRoutes)) ||
    (userData.role === LAUNDRY_DELIVERY &&
      !isAllowedRoute([links.orders()[0]]))
  ) {
    return router.createUrlTree(links.orders());
  }

  return true;
};
